export class SequenceNumber {
  public id!: number;
  public sequenceID!: number;
  public counter!: number;
  public year!: number;
  public number!: string;
  public inUse!: boolean;
}
